import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _539009a6 = () => interopDefault(import('..\\pages\\aboutUs\\index.vue' /* webpackChunkName: "pages/aboutUs/index" */))
const _598a2164 = () => interopDefault(import('..\\pages\\applicationIntroduction\\index.vue' /* webpackChunkName: "pages/applicationIntroduction/index" */))
const _7956d768 = () => interopDefault(import('..\\pages\\case\\index.vue' /* webpackChunkName: "pages/case/index" */))
const _2a124308 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _4b09f202 = () => interopDefault(import('..\\pages\\esg\\index.vue' /* webpackChunkName: "pages/esg/index" */))
const _700e5a94 = () => interopDefault(import('..\\pages\\joinUs\\index.vue' /* webpackChunkName: "pages/joinUs/index" */))
const _41cf1d02 = () => interopDefault(import('..\\pages\\klyr\\index.vue' /* webpackChunkName: "pages/klyr/index" */))
const _4cfc70c9 = () => interopDefault(import('..\\pages\\news\\index.vue' /* webpackChunkName: "pages/news/index" */))
const _24ff5370 = () => interopDefault(import('..\\pages\\technology\\index.vue' /* webpackChunkName: "pages/technology/index" */))
const _af50f728 = () => interopDefault(import('..\\pages\\applicationIntroduction\\b-end.vue' /* webpackChunkName: "pages/applicationIntroduction/b-end" */))
const _3c9bf36d = () => interopDefault(import('..\\pages\\applicationIntroduction\\c-end.vue' /* webpackChunkName: "pages/applicationIntroduction/c-end" */))
const _e4a4a11e = () => interopDefault(import('..\\pages\\applicationIntroduction\\g-end.vue' /* webpackChunkName: "pages/applicationIntroduction/g-end" */))
const _0e5c2914 = () => interopDefault(import('..\\pages\\case\\cnpc.vue' /* webpackChunkName: "pages/case/cnpc" */))
const _2c088004 = () => interopDefault(import('..\\pages\\case\\klsz.vue' /* webpackChunkName: "pages/case/klsz" */))
const _44504712 = () => interopDefault(import('..\\pages\\case\\ningbo.vue' /* webpackChunkName: "pages/case/ningbo" */))
const _748226f3 = () => interopDefault(import('..\\pages\\joinUs\\001.vue' /* webpackChunkName: "pages/joinUs/001" */))
const _74903e74 = () => interopDefault(import('..\\pages\\joinUs\\002.vue' /* webpackChunkName: "pages/joinUs/002" */))
const _749e55f5 = () => interopDefault(import('..\\pages\\joinUs\\003.vue' /* webpackChunkName: "pages/joinUs/003" */))
const _5c921c98 = () => interopDefault(import('..\\pages\\news\\icbc.vue' /* webpackChunkName: "pages/news/icbc" */))
const _c850403e = () => interopDefault(import('..\\pages\\news\\klsz.vue' /* webpackChunkName: "pages/news/klsz" */))
const _b4b790da = () => interopDefault(import('..\\pages\\news\\klyr.vue' /* webpackChunkName: "pages/news/klyr" */))
const _3e7d5d40 = () => interopDefault(import('..\\pages\\news\\klyr20250617.vue' /* webpackChunkName: "pages/news/klyr20250617" */))
const _11e95eaf = () => interopDefault(import('..\\pages\\technology\\arcturus.vue' /* webpackChunkName: "pages/technology/arcturus" */))
const _aef54aa6 = () => interopDefault(import('..\\pages\\technology\\canopus.vue' /* webpackChunkName: "pages/technology/canopus" */))
const _3bba9f53 = () => interopDefault(import('..\\pages\\technology\\cloud.vue' /* webpackChunkName: "pages/technology/cloud" */))
const _0f645bc0 = () => interopDefault(import('..\\pages\\technology\\procyon.vue' /* webpackChunkName: "pages/technology/procyon" */))
const _1bea1c56 = () => interopDefault(import('..\\pages\\technology\\rigel.vue' /* webpackChunkName: "pages/technology/rigel" */))
const _be2c5986 = () => interopDefault(import('..\\pages\\technology\\sirius.vue' /* webpackChunkName: "pages/technology/sirius" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/aboutUs",
    component: _539009a6,
    name: "aboutUs___zh"
  }, {
    path: "/applicationIntroduction",
    component: _598a2164,
    name: "applicationIntroduction___zh"
  }, {
    path: "/case",
    component: _7956d768,
    name: "case___zh"
  }, {
    path: "/en",
    component: _2a124308,
    name: "index___en"
  }, {
    path: "/esg",
    component: _4b09f202,
    name: "esg___zh"
  }, {
    path: "/joinUs",
    component: _700e5a94,
    name: "joinUs___zh"
  }, {
    path: "/klyr",
    component: _41cf1d02,
    name: "klyr___zh"
  }, {
    path: "/news",
    component: _4cfc70c9,
    name: "news___zh"
  }, {
    path: "/technology",
    component: _24ff5370,
    name: "technology___zh"
  }, {
    path: "/applicationIntroduction/b-end",
    component: _af50f728,
    name: "applicationIntroduction-b-end___zh"
  }, {
    path: "/applicationIntroduction/c-end",
    component: _3c9bf36d,
    name: "applicationIntroduction-c-end___zh"
  }, {
    path: "/applicationIntroduction/g-end",
    component: _e4a4a11e,
    name: "applicationIntroduction-g-end___zh"
  }, {
    path: "/case/cnpc",
    component: _0e5c2914,
    name: "case-cnpc___zh"
  }, {
    path: "/case/klsz",
    component: _2c088004,
    name: "case-klsz___zh"
  }, {
    path: "/case/ningbo",
    component: _44504712,
    name: "case-ningbo___zh"
  }, {
    path: "/en/aboutUs",
    component: _539009a6,
    name: "aboutUs___en"
  }, {
    path: "/en/applicationIntroduction",
    component: _598a2164,
    name: "applicationIntroduction___en"
  }, {
    path: "/en/case",
    component: _7956d768,
    name: "case___en"
  }, {
    path: "/en/esg",
    component: _4b09f202,
    name: "esg___en"
  }, {
    path: "/en/joinUs",
    component: _700e5a94,
    name: "joinUs___en"
  }, {
    path: "/en/klyr",
    component: _41cf1d02,
    name: "klyr___en"
  }, {
    path: "/en/news",
    component: _4cfc70c9,
    name: "news___en"
  }, {
    path: "/en/technology",
    component: _24ff5370,
    name: "technology___en"
  }, {
    path: "/joinUs/001",
    component: _748226f3,
    name: "joinUs-001___zh"
  }, {
    path: "/joinUs/002",
    component: _74903e74,
    name: "joinUs-002___zh"
  }, {
    path: "/joinUs/003",
    component: _749e55f5,
    name: "joinUs-003___zh"
  }, {
    path: "/news/icbc",
    component: _5c921c98,
    name: "news-icbc___zh"
  }, {
    path: "/news/klsz",
    component: _c850403e,
    name: "news-klsz___zh"
  }, {
    path: "/news/klyr",
    component: _b4b790da,
    name: "news-klyr___zh"
  }, {
    path: "/news/klyr20250617",
    component: _3e7d5d40,
    name: "news-klyr20250617___zh"
  }, {
    path: "/technology/arcturus",
    component: _11e95eaf,
    name: "technology-arcturus___zh"
  }, {
    path: "/technology/canopus",
    component: _aef54aa6,
    name: "technology-canopus___zh"
  }, {
    path: "/technology/cloud",
    component: _3bba9f53,
    name: "technology-cloud___zh"
  }, {
    path: "/technology/procyon",
    component: _0f645bc0,
    name: "technology-procyon___zh"
  }, {
    path: "/technology/rigel",
    component: _1bea1c56,
    name: "technology-rigel___zh"
  }, {
    path: "/technology/sirius",
    component: _be2c5986,
    name: "technology-sirius___zh"
  }, {
    path: "/en/applicationIntroduction/b-end",
    component: _af50f728,
    name: "applicationIntroduction-b-end___en"
  }, {
    path: "/en/applicationIntroduction/c-end",
    component: _3c9bf36d,
    name: "applicationIntroduction-c-end___en"
  }, {
    path: "/en/applicationIntroduction/g-end",
    component: _e4a4a11e,
    name: "applicationIntroduction-g-end___en"
  }, {
    path: "/en/case/cnpc",
    component: _0e5c2914,
    name: "case-cnpc___en"
  }, {
    path: "/en/case/klsz",
    component: _2c088004,
    name: "case-klsz___en"
  }, {
    path: "/en/case/ningbo",
    component: _44504712,
    name: "case-ningbo___en"
  }, {
    path: "/en/joinUs/001",
    component: _748226f3,
    name: "joinUs-001___en"
  }, {
    path: "/en/joinUs/002",
    component: _74903e74,
    name: "joinUs-002___en"
  }, {
    path: "/en/joinUs/003",
    component: _749e55f5,
    name: "joinUs-003___en"
  }, {
    path: "/en/news/icbc",
    component: _5c921c98,
    name: "news-icbc___en"
  }, {
    path: "/en/news/klsz",
    component: _c850403e,
    name: "news-klsz___en"
  }, {
    path: "/en/news/klyr",
    component: _b4b790da,
    name: "news-klyr___en"
  }, {
    path: "/en/news/klyr20250617",
    component: _3e7d5d40,
    name: "news-klyr20250617___en"
  }, {
    path: "/en/technology/arcturus",
    component: _11e95eaf,
    name: "technology-arcturus___en"
  }, {
    path: "/en/technology/canopus",
    component: _aef54aa6,
    name: "technology-canopus___en"
  }, {
    path: "/en/technology/cloud",
    component: _3bba9f53,
    name: "technology-cloud___en"
  }, {
    path: "/en/technology/procyon",
    component: _0f645bc0,
    name: "technology-procyon___en"
  }, {
    path: "/en/technology/rigel",
    component: _1bea1c56,
    name: "technology-rigel___en"
  }, {
    path: "/en/technology/sirius",
    component: _be2c5986,
    name: "technology-sirius___en"
  }, {
    path: "/",
    component: _2a124308,
    name: "index___zh"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
